export const transparentBg = {background: 'transparent'}
export const space = {marginTop: '25px'}
export const inputNormal = {background: 'white'}
export const inputRequired = {background: 'salmon'}



/** WEBPACK FOOTER **
 ** ./app/styles/index.js
 **/